export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_q02_b.f19851c0.png";